import { useState } from 'react'
import { PermissionButton } from '../components/Permissions.js'
import { Link } from 'react-router-dom'
import { useApi, useAsync } from '../lib/useApi.js'
import { ProjectCreation } from '../components/ProjectCreation.js'
import { Dialog, PageHeader, ErrorBox, Empty, Loading, StatusPill, relative } from '../components/ui.js'

export default function Projects() {
  const api = useApi()
  const { data, loading, error, reload } = useAsync(() => api.listProjects(), [api])

  const [creating, setCreating] = useState(false)
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState('all')
  const projects = (data?.projects ?? []).filter(
    (p) => p.name.toLowerCase().includes(search.toLowerCase()) && (filter === 'all' || p.status === filter),
  )

  return (
    <>
      <PageHeader
        title="Projects"
        description="Your applications, infrastructure, and project workspaces."
        actions={
          <PermissionButton
            permission="project:create"
            className="btn btn-primary"
            onClick={() => {
              setOpen(true)
            }}
          >
            New project
          </PermissionButton>
        }
      />
      <Dialog open={open} title="Create a project" busy={creating} onClose={() => setOpen(false)}>
        <ProjectCreation key={open ? 'open' : 'closed'} api={api} onBusy={setCreating} onCreated={() => { setOpen(false); reload() }} />
      </Dialog>
      <div className="toolbar">
        <div className="field">
          <label htmlFor="project-search">Search projects</label>
          <input
            id="project-search"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Find a project…"
          />
        </div>
        <div className="field">
          <label htmlFor="project-filter">Status</label>
          <select id="project-filter" value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="all">All statuses</option>
            {['active', 'provisioning', 'paused', 'failed', 'deleting', 'deleted'].map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <Loading />
        ) : error ? (
          <ErrorBox retry={reload}>{error}</ErrorBox>
        ) : !projects.length ? (
          <Empty>
            {data?.projects.length
              ? 'No matching projects. Try another search or status.'
              : 'No projects yet. Start with New project.'}
          </Empty>
        ) : (
          projects.map((p) => (
            <div className="row" key={p.id}>
              <div className="row-main">
                <div className="row-title">
                  <Link to={`/projects/${p.id}`}>{p.name}</Link>
                </div>
                <div className="row-sub">
                  {p.slug} · {p.databaseTier === 'd1' ? 'D1 · SQLite' : 'Neon · PostgreSQL'} ·{' '}
                  {relative(p.createdAt)}
                </div>
              </div>
              <StatusPill status={p.status} />
            </div>
          ))
        )}
      </div>
    </>
  )
}
